// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/services/estoqueService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { EstoquePosicaoItem, ReposicaoItem, PaginadoResponse } from '../types';

const BASE = '/api/estoque';

export const estoqueService = {
  async getPosicao(
    pagina = 1,
    tamanhoPagina = 20,
    busca?: string,
    localId = 0,
  ): Promise<PaginadoResponse<EstoquePosicaoItem>> {
    const { data } = await apiClient.get<PaginadoResponse<EstoquePosicaoItem>>(`${BASE}/posicao`, {
      params: {
        pagina,
        tamanhoPagina,
        busca: busca || undefined,
        localId: localId > 0 ? localId : undefined,
      },
    });
    return data;
  },

  async getReposicao(): Promise<ReposicaoItem[]> {
    const { data } = await apiClient.get<ReposicaoItem[]>(`${BASE}/reposicao`);
    return data;
  },
};
